import { Popover } from '@headlessui/react';
import { CpuChipIcon } from '@heroicons/react/24/outline';

import { ExportScope } from '../types';

import {
  VENDOR_FASTDUCT_PAGE,
  VENDOR_WENDES_PAGE,
  VENDOR_FASTDUCT_PROJECT,
  VENDOR_WENDES_PROJECT,
  VENDOR_B2_PAGE,
  VENDOR_B2_PROJECT,
  VENDOR_FASTDUCT_PLAIN,
} from '@/config';

enum Vendor {
  F = 'fast_duct',
  W = 'wendes',
  B = 'b2',
  P = 'fast_plain',
}

export type ExportToVendorProps = {
  creating?: boolean;
  outputTo: (
    vendorId: string,
    format: string,
    scope: string,
    params?: string,
  ) => void;
};

/**
 * Vendor integration used export menus
 * @date 2025/08/06
 */
export const EstimatingTool = ({ outputTo }: ExportToVendorProps) => (
  <Popover className="relative">
    {/* disabled waiting for full implementation in backend - 2025/08/13 */}
    <Popover.Button className="btn-title-tool mr-2">
      <CpuChipIcon className="size-4 text-blue-600 inline-block" />
      <span className="text-sm px-1">Estimating API</span>
    </Popover.Button>

    <Popover.Panel className="absolute z-500 ">
      <ul className="btn-popup-menu w-44">
        <Popover.Button
          className="btn-popup-menu-item border-b border-gray-300 text-xs text-left p-2 pl-6"
          onClick={() => outputTo(Vendor.F, 'csv', ExportScope.PG)}
        >
          {VENDOR_FASTDUCT_PAGE}
        </Popover.Button>
        <Popover.Button
          className="btn-popup-menu-item border-b border-gray-300 text-xs text-left p-2 pl-6"
          onClick={() => outputTo(Vendor.W, 'csv', ExportScope.PG)}
        >
          {VENDOR_WENDES_PAGE}
        </Popover.Button>
        <Popover.Button
          className="btn-popup-menu-item border-b border-gray-300 text-xs text-left p-2 pl-6"
          onClick={() => outputTo(Vendor.F, 'csv', ExportScope.PJ)}
        >
          {VENDOR_FASTDUCT_PROJECT}
        </Popover.Button>
        <Popover.Button
          className="btn-popup-menu-item border-b border-gray-300 text-xs text-left p-2 pl-6"
          onClick={() => outputTo(Vendor.W, 'csv', ExportScope.PJ)}
        >
          {VENDOR_WENDES_PROJECT}
        </Popover.Button>
        {/* == B2 PAGE == */}
        <Popover.Button
          className="btn-popup-menu-item border-b border-gray-300 text-xs text-left p-2 pl-6"
          onClick={() =>
            outputTo(
              Vendor.B,
              'xls',
              ExportScope.PG,
              '?grouped=false&segment_size=5&format=xls',
            )
          }
        >
          {VENDOR_B2_PAGE}
        </Popover.Button>
        <Popover.Button
          className="btn-popup-menu-item border-b border-gray-300 text-xs text-left p-2 pl-6"
          onClick={() =>
            outputTo(
              Vendor.B,
              'xls',
              ExportScope.PJ,
              '?grouped=false&segment_size=5&format=xls',
            )
          }
        >
          {VENDOR_B2_PROJECT}
        </Popover.Button>
        {/* == FAST PLAIN == */}
        <Popover.Button
          className="btn-popup-menu-item border-b border-gray-300 text-xs text-left p-2 pl-6"
          onClick={() => outputTo(Vendor.P, 'csv', ExportScope.PG)}
        >
          {VENDOR_FASTDUCT_PLAIN}
        </Popover.Button>
        {/* <li className="btn-popup-menu-item">Quotesoft</li> */}
      </ul>
    </Popover.Panel>
  </Popover>
);
